import {API} from "./API";
import {AppCookies} from "../core/Cookies";
import {AppConfig} from "../config";

export class FilesAPI extends API<null> {

	constructor () {
		super("files");
	}

	public uploadFile(file: any, parentId: string, parentType: string): Promise<any> {

		let url = `/${this.endpoint}`;
		// let payload = item;

		var data = new FormData();
		data.append('parentId', parentId);
		data.append('parentType', parentType)
		data.append('file', file);

		return API.axiosInstance.post(url, data,{
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

	public downloadFile (fileId: string) {
		let url = `/${this.endpoint}/${fileId}`;
		return API.axiosInstance.get(url, {responseType: 'blob'})
	}

	public getFileForPreviewURL (fileId: string) {
		return `${AppConfig().api.baseUrl}/${this.endpoint}/${fileId}/preview?auth=${AppCookies.getAccessToken()}`;
	}

	public deleteFile (fileId: string) {
		let url = `/${this.endpoint}/${fileId}`;
		return API.axiosInstance.delete(url)
	}
}
